
import { mdiClose, mdiPaperclip } from "@mdi/js"
import { uploadArticle } from '@/api/article.service.js'
import featureComponent from '@/mixins/featureComponent'
import FileMin from '@/components/base/FileMin.vue'

export default {
  name: 'UrlComponent',
  components: {
    FileMin,
  },
  mixins: [featureComponent],
  data: () => ({
    url: '',
    isLoading: false,
    mdiClose,
    mdiPaperclip,
  }),
  computed: {
    listItems() {
      if (this.$attrs.multiple) {
        return this.model || []
      } else {
        return this.model ? [this.model] : []
      }
    },
  },
  methods: {
    async onAdd() {
      if (!this.url || this.isLoading) {
        return;
      }

      if (Array.isArray(this.model)) {
        if (this.model.some((s) => s?.url === this.url)) {
          return;
        }
      } else if (this.model === this.url) {
        return;
      }
      this.isLoading = true;
      try {
        const res = await this.$api.run(uploadArticle, { url: this.url })
        const source = { ...res, type: "website" };
        this.$store.dispatch('addSource', source);
        this.modelInsert(source)
      } catch (error) {
        this.$store.dispatch('setError', this.$t(`messages.${error?.message}` || 'messages.upload_error_generic'))
        console.warn("website upload err: ", error)
      }

      this.isLoading = false;
      if (this.$attrs.multiple) {
        this.url = ''
      }
    },
    modelInsert(val) {
      if (this.$attrs.multiple) {
        if (Array.isArray(this.model)) {
          this.model = [...this.model, val];
          return
        } else if (this.model) {
          this.model = [this.model, val]
        } else {
          this.model = [val];
        }
        return;
      }
      this.model = val;
    },
    onRemove(index) {
      if (Array.isArray(this.model)) {
        this.model.splice(index, 1)
      } else {
        this.model = null
        this.url = ''
      }
    },
  },
}
